import request from "@/utils/request.js";

const userApi = {
  Login: "/auth/login",
  WXLogin: "/auth/wx-login",
  WecomLogin: "/auth/wecom-login",
  Verify: "/auth/verify",
  Logout: "/auth/logout",
  ForgePassword: "/auth/forge-password",
  Register: "/auth/register",
  twoStepCode: "/auth/2step-code",
  SendSms: "/account/sms",
  SendSmsErr: "/account/sms_err",
  // get my info
  UserInfo: "/user/info"
};

export function login(parameter) {
  return request({
    url: userApi.Login,
    method: "post",
    data: parameter
  });
}
export function wxLogin(parameter) {
  return request({
    url: userApi.WXLogin,
    method: "post",
    data: parameter
  });
}
export function wecomLogin(parameter) {
  return request({
    url: userApi.WecomLogin,
    method: "post",
    data: parameter
  });
}
export function verify(parameter) {
  return request({
    url: userApi.Verify,
    method: "post",
    data: parameter
  });
}

export function getSmsCaptcha(parameter) {
  return request({
    url: userApi.SendSms,
    method: "post",
    data: parameter
  });
}

export function getInfo() {
  return request({
    url: userApi.UserInfo,
    method: "get",
    headers: {
      "Content-Type": "application/json;charset=UTF-8"
    }
  });
}

export function logout() {
  return request({
    url: userApi.Logout,
    method: "post",
    headers: {
      "Content-Type": "application/json;charset=UTF-8"
    }
  });
}

/**
 * get user 2step code open?
 * @param parameter {*}
 */
export function get2step(parameter) {
  return request({
    url: userApi.twoStepCode,
    method: "post",
    data: parameter
  });
}
